import { render, staticRenderFns } from "./UsersNumberItem.vue?vue&type=template&id=d56c6d9c&scoped=true&"
import script from "./UsersNumberItem.vue?vue&type=script&lang=js&"
export * from "./UsersNumberItem.vue?vue&type=script&lang=js&"
import style0 from "./UsersNumberItem.vue?vue&type=style&index=0&id=d56c6d9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56c6d9c",
  null
  
)

export default component.exports